import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { InternalLink } from 'smartsuite-ui';
import { getSystemOrigin } from '../../../shared/hooks/linkHooks';
import DashboardContext from '../../../shared/hooks/dashboardContext';

function getPassengerLinkForPassengerId(
    passengerId,
    linkConfig,
    systemManifest
) {
    const systemOrigin = getSystemOrigin(linkConfig, systemManifest);
    const pathname = linkConfig.pathName;
    const queryParams = `?passenger_id=${passengerId}`;

    // systemOrigin = https://localhost/WebClient
    // pathname = /Common.Airport/Query/PassengerDetails.aspx
    // queryParams = ?passenger_id=493
    return `${systemOrigin}${pathname}${queryParams}`;
}

export default function PassengerDetailLinkWithPassengerId(props) {
    const { systemManifest } = useContext(DashboardContext);

    const passengerId = props.resultRow[props.columnConfig.idDataKey];
    const hasAccess = props.resultRow[props.columnConfig.hasAccessDataKey];

    if (!hasAccess || !passengerId) {
        return <span>{props.children}</span>;
    }

    return (
        <InternalLink
            canViewLink={true}
            href={getPassengerLinkForPassengerId(
                passengerId,
                props.columnConfig.linkConfig,
                systemManifest
            )}
            openInNewTab={props.openInNewTab}
        >
            {props.children}
        </InternalLink>
    );
}

PassengerDetailLinkWithPassengerId.propTypes = {
    children: PropTypes.node,
    columnConfig: PropTypes.instanceOf(Object).isRequired,
    openInNewTab: PropTypes.bool,
    resultRow: PropTypes.instanceOf(Object),
};

PassengerDetailLinkWithPassengerId.defaultProps = {
    openInNewTab: false,
};
